import { render } from "./AssetMapPostDashboard.vue?vue&type=template&id=5df82a55&scoped=true"
import script from "./AssetMapPostDashboard.vue?vue&type=script&lang=js"
export * from "./AssetMapPostDashboard.vue?vue&type=script&lang=js"

import "./AssetMapPostDashboard.vue?vue&type=style&index=0&id=5df82a55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df82a55"]])

export default __exports__